import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from '../helpers/emblaDots';
import Autoplay from 'embla-carousel-autoplay';
const selectors = {
    heroBannerCarousel: '[data-hero-banner-carousel]',
    heroBannerCarouselAutoplay: 'data-hero-banner-carousel-autoplay',
    heroBannerCarouselSpeed: 'data-hero-banner-carousel-speed',
    heroBannerCarouselViewport: '[data-hero-banner-carousel-viewport]',
    heroBannerCarouselPrev: '[data-hero-banner-carousel-prev]',
    heroBannerCarouselNext: '[data-hero-banner-carousel-next]',
    heroBannerCarouselDots: '[data-hero-banner-carousel-dots]',
};
const bannerCarousel = () => {
    const heroBannerCarousels = document.querySelectorAll(selectors.heroBannerCarousel);
    if (heroBannerCarousels) {
        heroBannerCarousels.forEach((carousel) => {
            let embla;
            const speed = parseInt(carousel.getAttribute(selectors.heroBannerCarouselSpeed));
            const viewportNode = carousel.querySelector(selectors.heroBannerCarouselViewport);
            const prevButtonNode = carousel.querySelector(selectors.heroBannerCarouselPrev);
            const nextButtonNode = carousel.querySelector(selectors.heroBannerCarouselNext);
            const dotsNode = carousel.querySelector(selectors.heroBannerCarouselDots);
            const options = {
                loop: true,
                align: 'start',
            };
            if (carousel.getAttribute(selectors.heroBannerCarouselAutoplay) == 'true') {
                embla = EmblaCarousel(viewportNode, options, [Autoplay({ playOnInit: true, delay: speed, stopOnInteraction: false, stopOnMouseEnter: true })]);
            }
            else {
                embla = EmblaCarousel(viewportNode, options);
            }
            if (dotsNode) {
                addDotBtnsAndClickHandlers(embla, dotsNode);
            }
            if (prevButtonNode && nextButtonNode) {
                prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
                nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
            }
        });
    }
};
export { bannerCarousel };
